export default function StyledLink({
  url = '#',
  display = null,
  className = '',
}) {
  return (
    <a
      className={`${className} underline underline underline-offset-[6px] decoration-solid`}
      href={url}
    >
      {display}
    </a>
  );
}
